import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 44px;\n  margin-top: -44px;\n  position: absolute;\n  right: 20px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 300;\n  margin-top: 3px;\n  margin-bottom: 0;\n  position: absolute;\n  left: 0;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  font-size: 12px;\n  font-weight: normal;\n  color: ", ";\n  margin-top: 4px;\n\n  a {\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  height: 44px;\n  border: 1px solid ", ";\n  padding: ", ";\n  ", "\n  border-radius: ", ";\n  font-size: 14px;\n  color: ", ";\n  width: 100%;\n  transition: border-color 250ms ease-in-out;\n  line-height: 1.5;\n  box-sizing: border-box;\n\n  -webkit-appearance: none;\n\n  ", "\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus,\n  &:hover {\n    outline: 0;\n    border-color: ", ";\n  }\n  @media screen and (max-width: ", "px) {\n    font-size: 16px;\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  height: 14px;\n  margin: 13px 5px;\n  opacity: 0.5;\n  position: absolute;\n  left: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  height: 24px;\n  margin: 11px 9px;\n  outline: none;\n  position: absolute;\n  right: 0;\n  width: 24px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 16px;\n  margin: 15px 16px;\n  right: 0;\n\n  & > svg {\n    height: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 14px;\n  margin: 15px 16px;\n  opacity: 0.3;\n  position: absolute;\n  right: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.57;\n  color: ", ";\n  margin-bottom: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  user-select: none;\n  position: relative;\n  transition: opacity 150ms ease-in-out;\n\n  /* Note: This gives us room to render an error label below the text field */\n  padding-bottom: 30px;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MaskedInput from 'react-text-mask';
import { AcornsIcon } from '@acorns/icons';
import QuestionMarkLightPath from '../../assets/icons/question-mark-light.svg';
import QuestionMarkPath from '../../assets/icons/question-mark.svg';
import styled from '../../utils/styling/styled-components';
import { ScreenReaderOnly } from '../../ScreenReaderOnly';
import { TEXT_INPUT, TEXT_INPUT_HELP_TEXT, TEXT_INPUT_LABEL, TEXT_INPUT_ERROR, TEXT_INPUT_LOCKED_ICON } from '../../utils/testing/TestIDs';
import { FieldError } from '../FieldError';
var Container = styled.div(_templateObject(), function (props) {
  return props.disabled && "\n    opacity: 0.3;\n  ";
});
var Label = styled.label(_templateObject2(), function (props) {
  return props.theme.colors.slate;
});
var Padlock = styled(AcornsIcon)(_templateObject3());
var IconContainer = styled.span(_templateObject4());
var TooltipButton = styled.button(_templateObject5());
var Prefix = styled.span(_templateObject6());
var TooltipIcon = styled.img(_templateObject7());
var StyledInput = styled.input(_templateObject8(), function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.tooltip ? '0 44px 0 16px' : '0 16px';
}, function (props) {
  var _props$label;

  return (props.type === 'password' || props.label && typeof props.label === 'string' && ((_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.toLowerCase().includes('password'))) && (props.toggleIcon ? 'padding-right: 50px;' : 'padding-right: 70px;');
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.maxLength ? "\n    &.char-counter {\n      padding: 0 44px 0 16px;\n    }\n    " : '';
}, function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props['data-error'] && "\n      border-color: ".concat(props.theme.colors.red, ";\n      color: ").concat(props.theme.colors.red, ";\n\n      &:focus, &:hover {\n        border-color: ").concat(props.theme.colors.red, ";\n      }\n    ");
}, function (props) {
  return props.locked && "\n      color: ".concat(props.theme.colors.stone, ";\n      background-color: #fbfbfb;\n\n      &:hover {\n        border-color: ").concat(props.theme.colors.stoneLight, ";\n      }\n    ");
});
var StyledMaskedInput = StyledInput.withComponent(MaskedInput);
var HelperText = styled.div(_templateObject9(), function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.theme.colors.stone;
});
var ErrorLabel = styled(FieldError)(_templateObject10(), function (props) {
  return props.theme.colors.red;
});
export var CharsCounter = styled.div(_templateObject11(), function (props) {
  return props.theme.colors.slate;
}); // placeholderChar is NOT a space. It's â followed by 2 PAD characters.
// This is needed because if we have spaces in our value, we
// can't use a space as a placeholder character

var TextInput = function TextInput(_ref) {
  var adornment = _ref.adornment,
      autocomplete = _ref.autocomplete,
      autoFocus = _ref.autoFocus,
      charCounter = _ref.charCounter,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      errorText = _ref.errorText,
      _ref$guide = _ref.guide,
      guide = _ref$guide === void 0 ? true : _ref$guide,
      _ref$hasHiddenLabel = _ref.hasHiddenLabel,
      hasHiddenLabel = _ref$hasHiddenLabel === void 0 ? false : _ref$hasHiddenLabel,
      helperText = _ref.helperText,
      id = _ref.id,
      inputMode = _ref.inputMode,
      label = _ref.label,
      link = _ref.link,
      locked = _ref.locked,
      mask = _ref.mask,
      maxLength = _ref.maxLength,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      _ref$placeholderChar = _ref.placeholderChar,
      placeholderChar = _ref$placeholderChar === void 0 ? ' ' : _ref$placeholderChar,
      readOnly = _ref.readOnly,
      required = _ref.required,
      style = _ref.style,
      toggleIcon = _ref.toggleIcon,
      tooltip = _ref.tooltip,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      value = _ref.value,
      noPaste = _ref.noPaste,
      prefix = _ref.prefix;
  var Input = mask ? StyledMaskedInput : StyledInput;

  var NO_PASTE = function NO_PASTE(e) {
    e.preventDefault();
  };

  var formattedLabel = required ? "".concat(label, " *") : label;
  var isDisabled = disabled || locked;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    disabled: disabled,
    style: style
  }, label && /*#__PURE__*/React.createElement(Label, {
    "data-testid": TEXT_INPUT_LABEL,
    htmlFor: id
  }, hasHiddenLabel ? /*#__PURE__*/React.createElement(ScreenReaderOnly, null, formattedLabel) : formattedLabel), prefix && /*#__PURE__*/React.createElement(Prefix, null, prefix), /*#__PURE__*/React.createElement(Input, {
    autoComplete: autocomplete,
    autoFocus: autoFocus,
    className: maxLength && charCounter ? 'char-counter' : '',
    "data-testid": TEXT_INPUT,
    "data-error": error,
    disabled: isDisabled,
    locked: locked,
    guide: guide,
    id: id,
    inputMode: inputMode,
    label: label,
    mask: mask,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    placeholderChar: placeholderChar,
    readOnly: readOnly,
    required: required,
    tooltip: tooltip,
    type: type,
    charCounter: charCounter,
    maxLength: maxLength,
    toggleIcon: toggleIcon,
    value: value,
    onCopy: noPaste && NO_PASTE,
    onPaste: noPaste && NO_PASTE,
    onDrag: noPaste && NO_PASTE,
    onDrop: noPaste && NO_PASTE
  }), maxLength && charCounter && /*#__PURE__*/React.createElement(CharsCounter, null, maxLength - (value || '').length), adornment && /*#__PURE__*/React.createElement(IconContainer, null, adornment), locked && /*#__PURE__*/React.createElement(Padlock, {
    icon: AcornsIcon.Icon.PadlockHollow,
    "data-testid": TEXT_INPUT_LOCKED_ICON
  }), tooltip && /*#__PURE__*/React.createElement(TooltipButton, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(TooltipIcon, {
    src: tooltip === 'primary' ? QuestionMarkPath : QuestionMarkLightPath,
    alt: ""
  })), helperText && !error ? /*#__PURE__*/React.createElement(HelperText, {
    "data-testid": TEXT_INPUT_HELP_TEXT
  }, link ? /*#__PURE__*/React.createElement("a", {
    href: link
  }, helperText) : name === 'newPassword' ? !errorText && helperText : helperText) : null, error && errorText && /*#__PURE__*/React.createElement(ErrorLabel, {
    "data-testid": TEXT_INPUT_ERROR,
    fieldId: id,
    errorText: errorText
  }));
};

export { TextInput };